<template>
  <Modal
    :is-open="showFilters"
    no-footer
    class="z-10 flex items-center justify-center"
    container-class="max-h-full rounded-lg"
  >
    <div>
      <div class="flex flex-col items-center gap-4 p-6">
        <div class="flex flex-wrap items-end justify-center gap-4 place-self-start">
          <div class="flex w-full max-w-xs flex-col">
            <label for="estados-uso" class="text-sm font-medium tracking-wide text-gray-700">
              <span>Estado uso</span>
            </label>
            <select
              class="w-full appearance-none truncate transition duration-150 ease-in-out sm:text-sm"
              type="text"
              id="estados-uso"
              v-model="filtros.estadoUso"
            >
              <!-- <option :value="null">Todos los estados</option> -->
              <option v-for="estado in estadosUso" :key="estado.id" :value="estado">
                {{ estado.descripcion }}
              </option>
            </select>
          </div>
          <div class="flex w-full max-w-xs flex-col">
            <label for="estados-pago" class="text-sm font-medium tracking-wide text-gray-700">
              <span>Estado pago</span>
            </label>
            <select
              class="w-full appearance-none truncate transition duration-150 ease-in-out sm:text-sm"
              type="text"
              id="estados-pago"
              v-model="filtros.estadoPago"
            >
              <!-- <option :value="null">Todos los estados</option> -->
              <option v-for="estado in estadosPago" :key="estado.id" :value="estado">
                {{ estado.descripcion }}
              </option>
            </select>
          </div>
          <div class="flex w-full max-w-xs flex-col items-center">
            <div class="text-sm font-medium tracking-wide text-gray-700">Fecha de creación</div>
            <div class="flex w-full space-x-2">
              <datetime
                class="theme-colescba relative grow"
                type="date"
                input-id="creacion-desde"
                placeholder="Fecha desde"
                input-class="block w-full sm:text-sm  transition duration-150 ease-in-out"
                v-model="filtros.fechaCreacion.desde"
                zone="America/Argentina/Buenos_Aires"
                value-zone="America/Argentina/Buenos_Aires"
                format="dd/MM/yyyy"
                :phrases="{ ok: 'Aceptar', cancel: 'Cancelar' }"
                :min-datetime="minDateFrom"
                :max-datetime="maxDateCreacionFrom"
              >
                <template #after>
                  <div class="absolute right-2 top-0 flex h-full items-center">
                    <SolidXIcon
                      class="h-4 w-4 cursor-pointer text-gray-400"
                      @click="filtros.fechaCreacion.desde = null"
                    />
                  </div>
                </template>
              </datetime>
              <datetime
                class="theme-colescba relative grow"
                type="date"
                input-id="creacion-hasta"
                placeholder="Fecha hasta"
                input-class="block w-full sm:text-sm  transition duration-150 ease-in-out"
                v-model="filtros.fechaCreacion.hasta"
                zone="America/Argentina/Buenos_Aires"
                value-zone="America/Argentina/Buenos_Aires"
                format="dd/MM/yyyy"
                :phrases="{ ok: 'Aceptar', cancel: 'Cancelar' }"
                :min-datetime="minDateCreacionTo"
                :max-datetime="maxDateTo"
              >
                <template #after>
                  <div class="absolute right-2 top-0 flex h-full items-center">
                    <SolidXIcon
                      class="h-4 w-4 cursor-pointer text-gray-400"
                      @click="filtros.fechaCreacion.hasta = null"
                    />
                  </div>
                </template>
              </datetime>
            </div>
          </div>
          <div class="flex w-full max-w-xs flex-col items-center">
            <div class="text-sm font-medium tracking-wide text-gray-700">Fecha de vencimiento</div>
            <div class="flex w-full space-x-2">
              <datetime
                class="theme-colescba relative grow"
                type="date"
                input-id="vencimiento-desde"
                placeholder="Fecha desde"
                input-class="block w-full sm:text-sm  transition duration-150 ease-in-out"
                v-model="filtros.fechaVencimiento.desde"
                zone="America/Argentina/Buenos_Aires"
                value-zone="America/Argentina/Buenos_Aires"
                format="dd/MM/yyyy"
                :phrases="{ ok: 'Aceptar', cancel: 'Cancelar' }"
                :min-datetime="minDateFrom"
                :max-datetime="maxDateVencimientoFrom"
              >
                <template #after>
                  <div class="absolute right-2 top-0 flex h-full items-center">
                    <SolidXIcon
                      class="h-4 w-4 cursor-pointer text-gray-400"
                      @click="filtros.fechaVencimiento.desde = null"
                    />
                  </div>
                </template>
              </datetime>
              <datetime
                class="theme-colescba relative grow"
                type="date"
                input-id="vencimiento-hasta"
                placeholder="Fecha hasta"
                input-class="block w-full sm:text-sm  transition duration-150 ease-in-out"
                v-model="filtros.fechaVencimiento.hasta"
                zone="America/Argentina/Buenos_Aires"
                value-zone="America/Argentina/Buenos_Aires"
                format="dd/MM/yyyy"
                :phrases="{ ok: 'Aceptar', cancel: 'Cancelar' }"
                :min-datetime="minDateVencimientoTo"
                :max-datetime="maxDateTo"
              >
                <template #after>
                  <div class="absolute right-2 top-0 flex h-full items-center">
                    <SolidXIcon
                      class="h-4 w-4 cursor-pointer text-gray-400"
                      @click="filtros.fechaVencimiento.hasta = null"
                    />
                  </div>
                </template>
              </datetime>
            </div>
          </div>
        </div>
        <div class="flex w-full max-w-xs flex-col">
          <label for="sedes" class="text-sm font-medium tracking-wide text-gray-700">
            <span>Delegación</span>
          </label>
          <select
            class="w-full appearance-none truncate transition duration-150 ease-in-out sm:text-sm"
            type="text"
            id="sedes"
            v-model="filtros.sede"
          >
            <option :value="null" selected>Todas las sedes</option>
            <option v-for="sede in sedes" :key="sede.id" :value="sede">
              {{ tipoSede(sede.tipo_id) }}
              {{ sede.descripcion }}
            </option>
          </select>
        </div>
      </div>
      <div
        class="flex items-center justify-end space-x-4 rounded-b-lg bg-gray-50 px-4 py-3 sm:px-6"
      >
        <span class="flex w-full rounded-md shadow-sm sm:w-auto">
          <button
            @click="$emit('filters:hide')"
            type="button"
            class="focus:shadow-outline inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm transition duration-150 ease-in-out hover:bg-cool-gray-200 focus:border-blue-300 focus:outline-none sm:text-sm"
          >
            Cerrar
          </button>
        </span>

        <span class="flex w-full rounded-md shadow-sm sm:w-auto">
          <button
            @click="$emit('filters:change', getFiltros())"
            type="button"
            class="focus:shadow-outline inline-flex w-full justify-center rounded-md border border-gray-300 bg-blue-brand-500 px-4 py-2 text-base font-medium text-white shadow-sm transition duration-150 ease-in-out hover:bg-blue-brand-700 focus:border-blue-300 focus:outline-none sm:text-sm"
          >
            Aplicar
          </button>
        </span>
      </div>
    </div>
  </Modal>
</template>

<script>
import { useService } from '@colescba/app-vue'
import { useSession, useAcreditacionServicio } from '@colescba/ui'

import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  props: {
    showFilters: { type: Boolean, required: true },
  },

  mixins: [useService('portalPagos'), useSession(), useAcreditacionServicio()],

  data() {
    return {
      rangoValido: {
        desde: moment().subtract(365, 'd'),
        hasta: moment().add(30, 'd'),
      },
      estadosUso: [],
      estadosPago: [],
      sedes: [],
      filtros: {
        estadoUso: null,
        estadoPago: null,
        sede: null,
        fechaCreacion: {
          desde: null,
          hasta: null,
        },
        fechaVencimiento: {
          desde: null,
          hasta: null,
        },
      },
    }
  },

  async mounted() {
    const [promiseUso, promisePago, promiseSedes] = await Promise.allSettled([
      this.portalPagos.getEstadosUso(this.user.cuitCuil.numero),
      this.portalPagos.getEstadosPago(this.user.cuitCuil.numero),
      this.portalPagos.getSedes(this.user.cuitCuil.numero),
    ])
    this.estadosUso = await promiseUso.value
    this.estadosPago = await promisePago.value
    this.sedes = await promiseSedes.value
    this.filtros.estadoUso = this.estadosUso.find(e => e.id.trim() == 'USADO')
    this.filtros.estadoPago = this.estadosPago.find(e => e.id.trim() == 'A_VERIFICAR')
    if (this.userHasAnyRole(['CAJERO'])) {
      if (!this.sedeCajero) {
        const rolCajero = this.rolesAcreditados.find(rol => rol.codigo === 'CAJERO')
        const oficinaId = rolCajero.oficinas[0].oficinaId
        await this.addSedeCajero({
          cuitCuil: this.user.cuitCuil.numero,
          portalPagos: this.portalPagos,
          oficinaId,
        })
      }
      this.filtros.sede = this.sedeCajero
    }
    this.$emit('filters:change', this.getFiltros())
  },

  computed: {
    ...mapGetters({
      sedeCajero: 'app/sedeCajero',
    }),
    minDateFrom() {
      return this.rangoValido.desde.toISOString()
    },
    maxDateCreacionFrom() {
      let momentDate = this.filtros.fechaCreacion.hasta
        ? moment(this.filtros.fechaCreacion.hasta)
        : this.rangoValido.hasta
      return momentDate.toISOString()
    },
    minDateCreacionTo() {
      let momentDate = this.filtros.fechaCreacion.desde
        ? moment(this.filtros.fechaCreacion.desde)
        : this.rangoValido.desde
      return momentDate.toISOString()
    },
    maxDateVencimientoFrom() {
      let momentDate = this.filtros.fechaVencimiento.hasta
        ? moment(this.filtros.fechaVencimiento.hasta)
        : this.rangoValido.hasta
      return momentDate.toISOString()
    },
    minDateVencimientoTo() {
      let momentDate = this.filtros.fechaVencimiento.desde
        ? moment(this.filtros.fechaVencimiento.desde)
        : this.rangoValido.desde
      return momentDate.toISOString()
    },
    maxDateTo() {
      return this.rangoValido.hasta.toISOString()
    },
  },

  methods: {
    ...mapActions({
      addSedeCajero: 'app/addSedeCajero',
    }),
    getFiltros() {
      // copia de this.filtros para que los cambios se reflejen solo al aplicar los cambios
      return JSON.parse(JSON.stringify(this.filtros))
    },
    tipoSede(sede_id) {
      switch (sede_id) {
        case '1':
          return 'Delegación'
        case '2':
          return 'Sede Central'
        case '3':
          return 'Oficina Delegada'
        case '4':
          return 'Oficina de venta de materiales'
        default:
          return 'Delegación'
      }
    },
  },
}
</script>
<style scoped>
input[type='date'] {
  display: inline-block;
  position: relative;
}

input[type='date']::-webkit-calendar-picker-indicator {
  background: transparent;
  bottom: 0;
  color: transparent;
  cursor: pointer;
  height: auto;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
}
</style>
<style>
.vdatetime-popup {
  height: 490px;
  overflow: auto;
}

.vdatetime-popup__actions {
  position: absolute;
  bottom: 0;
  right: 0;
}

.vdatetime-calendar__navigation {
  user-select: none;
}
</style>
